import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { TrashIcon, EyeIcon, PlusIcon } from '@heroicons/react/24/outline';
import API_URL from '../config/apiConfig';

const DomainsPage = () => {
    const [domains, setDomains] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDomains();
    }, []);

    const fetchDomains = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_URL}/admin/domains`, {
                params: { adminKey: process.env.REACT_APP_ADMIN_KEY }
            });
            if (response.data.success) {
                setDomains(response.data.data.domains);
            }
        } catch (err) {
            console.error('Erreur lors de la récupération des domaines:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Supprimer ce domaine ?')) return;
        try {
            await axios.delete(`${API_URL}/admin/domains/${id}`, {
                data: { adminKey: process.env.REACT_APP_ADMIN_KEY }
            });
            fetchDomains();
        } catch (err) {
            console.error('Erreur lors de la suppression:', err);
        }
    };

    return (
        <div>
            <div className="flex justify-between mb-6">
                <h1 className="text-2xl font-semibold text-gray-700">Gestion des domaines</h1>
                <button className="flex items-center px-4 py-2 bg-[#E48B94] text-white rounded-md">
                    <PlusIcon className="w-5 h-5 mr-2" /> Nouveau domaine
                </button>
            </div>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Domaine</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"># Users</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
                        <th className="px-6 py-3" />
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">Chargement...</td>
                        </tr>
                    ) : domains.length > 0 ? (
                        domains.map((d) => (
                            <tr key={d.id}>
                                <td className="px-6 py-4 whitespace-nowrap">{d.domain}</td>
                                <td className="px-6 py-4 whitespace-nowrap">{d.userCount}</td>
                                <td className="px-6 py-4 whitespace-nowrap">{d.status}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-3">
                                    <Link to={`/admin/domains/${d.id}`} className="text-indigo-600 hover:text-indigo-900">
                                        <EyeIcon className="w-5 h-5" />
                                    </Link>
                                    <button onClick={() => handleDelete(d.id)} className="text-red-600 hover:text-red-900">
                                        <TrashIcon className="w-5 h-5" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">Aucun domaine</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DomainsPage;